import { Button } from "@mui/material";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { updatePortfolio } from "../../../feature/portfolio/portfolioSlice";
import EditorToolbar, { formats, modules } from "./EditorToolbar";
import "./editPortfolio.scss";

const EditPortfoilo = () => {
  const location = useLocation();
  const {
    title,
    technology,
    category,
    liveLink,
    gitClient,
    gitServer,
    _id,
    image,
    body,
  } = location.state;

  const [portData, setPortData] = useState({
    title: title,
    technology: technology,
    category: category,
    liveLink: liveLink,
    gitClient: { value: gitClient },
    gitServer: { value: gitServer },
  });
  const [newBody, setNewBody] = useState(body);
  const [newImg, setNewImg] = useState("");
  const [imgUrl, setImgUrl] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPortData({ ...portData, [name]: value });
  };

  const inputClear = () => {
    setPortData({
      title: "",
      technology: "",
      category: "",
      liveLink: "",
      gitClient: { value: `` },
      gitServer: { value: `` },
    });
    setNewBody({ value: null });
  };

  const handleImgUpload = () => {
    const myData = new FormData();
    myData.append("file", newImg);
    myData.append("upload_preset", "portfolio");
    myData.append("cloud_name", "djwncpbir");

    fetch("https://api.cloudinary.com/v1_1/djwncpbir/image/upload", {
      method: "post",
      body: myData,
    })
      .then((res) => res.json())
      .then((data) => setImgUrl(data.url))
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const portfolioData = {
      title: portData.title,
      image: imgUrl,
      technology: portData.technology,
      category: portData.category,
      liveLink: portData.liveLink,
      gitClient: portData.gitClient,
      gitServer: portData.gitServer,
      body: newBody,
      id: _id,
    };
    dispatch(updatePortfolio(portfolioData));
    inputClear();
    toast.success("Portfolio Update successfully", {
      position: "bottom-right",
      autoClose: 3000,
      theme: "dark",
      pauseOnHover: true,
      draggable: true,
      Limit: 1,
    });
    setTimeout(() => {
      navigate("/dashboard/all_portfolio", { replace: true });
    }, 3000);
  };

  return (
    <div className="create-portfolio-container">
      <h2>Update Portfolio: </h2>
      <div className="inp-portfolio">
        <form onSubmit={handleUpdate}>
          <input
            className="title common-input"
            type="text"
            name="title"
            onChange={handleChange}
            value={portData.title}
            placeholder="Title"
          />
          <br />
          <div className="file-inp">
            <input
              type="file"
              name="image"
              onChange={(e) => setNewImg(e.target.files[0])}
            />
            <Button className="img-btn" onClick={handleImgUpload}>
              Upload
            </Button>
          </div>
          <input
            className="common-input"
            type="text"
            name="technology"
            onChange={handleChange}
            value={portData.technology}
            placeholder="Technology"
          />
          <div className="half-inp">
            <input
              className="common-input"
              type="text"
              name="category"
              onChange={handleChange}
              value={portData.category}
              placeholder="Category"
            />
            <input
              className="common-input"
              type="text"
              name="liveLink"
              onChange={handleChange}
              value={portData.liveLink}
              placeholder="Live Link"
            />
          </div>
          <div className="half-inp">
            <textarea
              className="common-input"
              type="text"
              name="gitClient"
              onChange={handleChange}
              value={portData.gitClient.value}
              placeholder="Git Client"
            ></textarea>

            <textarea
              className="common-input"
              type="text"
              name="gitServer"
              onChange={handleChange}
              value={portData.gitServer.value}
              placeholder="Git Server"
            ></textarea>
          </div>
          <div className="text-editor">
            <EditorToolbar />
            <ReactQuill
              className="text-aria"
              theme="snow"
              value={body.value}
              onChange={(value) => setNewBody({ value })}
              placeholder={"Write Your Blog..."}
              modules={modules}
              formats={formats}
            />
          </div>
          <Button className="submit-btn" type="submit">
            Update
          </Button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditPortfoilo;
